import { useHistory, useParams } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import NavBar from './navbar';
import Footer from './footer';
import ModalComment from './modal-comment';
import UserService from '../service/user.service';

export default function Profile({ user, admins, region }) {
    const { id } = useParams();
    const history = useHistory();
    const hasFetched = useRef(false);
    const [model, setModel] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [comments, setComments] = useState([]);
    const [addComment, setAddComment] = useState(false);
    const [delModal, setDelModal] = useState(false);
    const [delErr, setDelErr] = useState(false);
    const currency = region === 'kz' ? 5 : 1;

    useEffect(() => {
        if (!hasFetched.current) {
            hasFetched.current = true;
            UserService.getModel(id, user.id).then(response => {
                setModel(response.data);
                if (user.id === response.data.creator_id || admins.includes(user.id)) {
                    setIsAdmin(true);
                }
                loadComments();
            }).catch(err => console.error(err));
        }
    }, [id, user]);

    function loadComments() {
        UserService.getComments(id).then(res => setComments(res.data));
    }

    function handleDelete() {
        UserService.deleteModel(model.id, user.id).then(response => {
            setDelModal(true);
            setDelErr(!response.data);
        });
    }

    if (!model) {
        return (
            <>
                <NavBar text="Загрузка..." />
                <div style={{ paddingTop: 70, padding: '70px 16px' }}>
                    {[1, 2, 3].map(i => (
                        <div key={i} className="skeleton" style={{ height: 18, marginBottom: 10, borderRadius: 8 }} />
                    ))}
                </div>
            </>
        );
    }

    return (
        <>
            <NavBar text={model.name} />
            <ModalComment addComment={addComment} id={id} setAddComment={setAddComment} getComments={loadComments} />

            {delModal && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <h4>{delErr ? 'Ошибка' : 'Готово'}</h4>
                        <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>
                            {delErr ? 'Произошла ошибка при удалении' : 'Модель успешно удалена'}
                        </p>
                        <div className="modal-actions">
                            <button className="btn-primary" style={{ maxWidth: 120 }} onClick={() => {
                                setDelModal(false);
                                if (!delErr) history.push('/');
                            }}>OK</button>
                        </div>
                    </div>
                </div>
            )}

            <div className="profile-page">
                {isAdmin && (
                    <div className="admin-actions">
                        <button className="btn-outline" style={{ fontSize: 13 }} onClick={() => setAddComment(true)}>
                            + Отзыв
                        </button>
                        <button className="btn-danger" style={{ width: '100%', borderRadius: 12, padding: '10px 0' }}
                            onClick={handleDelete}>
                            Удалить модель
                        </button>
                    </div>
                )}

                <div className="photo-gallery">
                    {model.images.map((img, idx) => (
                        <img
                            key={idx}
                            src={`data:image/png;base64,${img}`}
                            alt={`${model.name} ${idx + 1}`}
                            className={model.images.length === 1 ? 'single' : ''}
                            style={model.images.length > 1 ? { width: 'calc(80vw)' } : {}}
                        />
                    ))}
                </div>

                <div className="profile-info">
                    <div className="model-name">{model.name}</div>
                    <div style={{ color: 'var(--text-secondary)', fontSize: 14 }}>{model.national}</div>

                    <div className="info-grid">
                        <div className="info-item">
                            <div className="label">Возраст</div>
                            <div className="value">{model.age} лет</div>
                        </div>
                        <div className="info-item">
                            <div className="label">Рост</div>
                            <div className="value">{model.height} см</div>
                        </div>
                        <div className="info-item">
                            <div className="label">Вес</div>
                            <div className="value">{model.weight} кг</div>
                        </div>
                        <div className="info-item">
                            <div className="label">Грудь</div>
                            <div className="value">{model.breast}</div>
                        </div>
                    </div>

                    {model.about && (
                        <>
                            <div className="section-title">О себе</div>
                            <p className="about-text">{model.about}</p>
                        </>
                    )}

                    <div className="section-title">Прайс-лист</div>
                    <div className="price-cards">
                        <div className="price-card">
                            <div className="price-type">🏠 На дом</div>
                            {model.home_ehour > 0 && <div className="price-row"><span>Евро час</span><span className="val">{model.home_ehour * currency}</span></div>}
                            {model.home_hour > 0 && <div className="price-row"><span>Час</span><span className="val">{model.home_hour * currency}</span></div>}
                            {model.home_night > 0 && <div className="price-row"><span>Ночь</span><span className="val">{model.home_night * currency}</span></div>}
                        </div>
                        <div className="price-card">
                            <div className="price-type">🚗 Выезд</div>
                            {model.out_ehour > 0 && <div className="price-row"><span>Евро час</span><span className="val">{model.out_ehour * currency}</span></div>}
                            {model.out_hour > 0 && <div className="price-row"><span>Час</span><span className="val">{model.out_hour * currency}</span></div>}
                            {model.out_night > 0 && <div className="price-row"><span>Ночь</span><span className="val">{model.out_night * currency}</span></div>}
                        </div>
                    </div>

                    {model.services && model.services.length > 0 && (
                        <>
                            <div className="section-title">Дополнительные услуги</div>
                            <div className="services-list">
                                {model.services.map((s, i) => (
                                    <span key={i} className="service-tag">{s}</span>
                                ))}
                            </div>
                        </>
                    )}

                    <div style={{ padding: '16px 0' }}>
                        <button className="btn-primary" onClick={() => history.push('/order/' + id)}>
                            Заказать модель
                        </button>
                    </div>

                    {comments.length > 0 && (
                        <>
                            <div className="section-title">Отзывы ({comments.length})</div>
                            {comments.map(c => (
                                <div key={c.id} className="comment-item">
                                    <div className="comment-meta">
                                        <span>{c.date}</span>
                                        <span>{c.name}</span>
                                    </div>
                                    <div className="comment-text">{c.text}</div>
                                    {isAdmin && (
                                        <button
                                            className="btn-danger"
                                            style={{ marginTop: 8, fontSize: 12, padding: '4px 10px' }}
                                            onClick={() => UserService.delComm(c.id, user.id).then(loadComments)}
                                        >
                                            Удалить
                                        </button>
                                    )}
                                </div>
                            ))}
                        </>
                    )}
                </div>

                <Footer />
            </div>
        </>
    );
}
